<ng-container [formGroup]="staffInfoForm">
  <div class="card-body staff-info">
    <h2>Staff Information</h2>
    <div class="form-row">
      <div class="form-group col-12">
        <label for="name" class="custom_label">HR Code</label>
        <input
          matInput
          type="text"
          id="name"
          formControlName="hr_code"
          class="form-control"
          placeholder="HR Code"
          name="hr_code"
          />
        <app-validation-error
          [formGroup]="staffInfoForm"
          [controlName]="'hr_code'"
        ></app-validation-error>
      </div>

      <div class="form-group col-12">
        <label for="name" class="custom_label">First Name*</label>
        <input
          matInput
          type="text"
          id="name"
          formControlName="first_name"
          class="form-control"
          placeholder="First Name"
          name="name"
          />
        <app-validation-error
          [formGroup]="staffInfoForm"
          [controlName]="'first_name'"
        ></app-validation-error>
      </div>
      <div class="form-group col-12">
        <label for="name" class="custom_label">Last Name*</label>
        <input
          matInput
          type="text"
          id="name"
          formControlName="last_name"
          class="form-control"
          placeholder="Last Name"
          name="name"
          />
        <app-validation-error
          [formGroup]="staffInfoForm"
          [controlName]="'last_name'"
        ></app-validation-error>
      </div>
      <div class="form-group col-12">
        <label for="name" class="custom_label">Email*</label>
        <input
          matInput
          type="email"
          id="name"
          formControlName="email"
          class="form-control"
          placeholder="Email"
          name="name"
          />

        <app-validation-error
          [formGroup]="staffInfoForm"
          [controlName]="'email'"
        ></app-validation-error>
      </div>
      @if (!isEdit) {
        <div class="form-group col-12">
          <label for="name" class="custom_label">Password*</label>
          <mat-slide-toggle
            style="float: right"
            class="b-one-switch"
            (change)="onChangeCreditLimit()"
            formControlName="can_login"
            >Can Login?</mat-slide-toggle
            >
            @if (CreditLimit) {
            }
            <div class="input-group">
              <input
                matInput
                type="{{ passwordType }}"
                id="name"
                formControlName="password"
                class="form-control"
                placeholder="Enter Password"
                name="name"
                />
              <span matSuffix>
                <img
                  (click)="showPassword()"
                  src="assets/img/auth/eye_icon.png"
                  alt="icon"
                  class="eye_icon mt-3"
                  />
              </span>
              <button
                class="btn custom-button ms-1"
                (click)="generateAndSetPassword()"
                type="button"
                >
                <mat-icon class="custom-icon">autorenew</mat-icon>
              </button>
            </div>
            @if (staffInfoForm.get('password')?.hasError('minlength')) {
              <mat-error
                >Password must be at least 12 characters</mat-error
                >
              }
              <app-validation-error
                [formGroup]="staffInfoForm"
                [controlName]="'password'"
              ></app-validation-error>
            </div>
          }

          <div class="form-group col-12">
            <label for="templates" class="custom_label">Offices*</label>
            <ng-select
              id="scopes"
              [items]="activeSubOffices"
              placeholder="Select Company"
              [closeOnSelect]="true"
              [multiple]="true"
              [compareWith]="isSameOffice"
              formControlName="attach_tenents"
              bindLabel="name"
              >
            </ng-select>
            <app-validation-error [formGroup]="staffInfoForm" [controlName]="'attach_tenents'"></app-validation-error>
          </div>

          <div class="form-group col-12">
            <label for="templates" class="custom_label">Default Office*</label>
            <ng-select
              [items]="filteredSubOffices"
              placeholder="Select Company"
              [closeOnSelect]="true"
              [compareWith]="isSameOffice"
              formControlName="current_tenent"
              bindLabel="name"
              >
            </ng-select>
            <app-validation-error [formGroup]="staffInfoForm" [controlName]="'current_tenent'"></app-validation-error>
          </div>
        </div>
      </div>
    </ng-container>
